module.exports = __webpack_public_path__ + "static/progetto_borgocascinaconti1-a4d09268fa137ae7872dcbbe7b645816.jpg";